import http from '../../../../api/axios';
import { apiUrl } from '../../../../api/apiUrl';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { TeamMemberForm } from '../../../../forms/TeamMember/TeamMemberForm';
import { TeamMember } from '../../../../types/TeamMember';
import { Loader } from '../../../../components/loader/Loader';
import { useTranslation } from '../../../../context/translationContext';
import { paths } from '../../../RouterContainer';
import { useBreadcrumbs } from '../../../../hooks/useBreadcrumbs';

/**
 * Page component represents members of team edit page
 */
export const UserTeamsMemberPage = () => {
  const { t } = useTranslation();
  const { companyId, teamId, membershipId } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState<TeamMember | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();
  const isCurrent = window.location.pathname.includes(`current`);

  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.COMPANY_TEAMS}/${companyId}/edit/${teamId}`,
        name: 'navigation.my-teams-edit',
      },
      {
        path: `${paths.COMPANY_TEAMS}/${companyId}/edit/${teamId}/${paths.MEMBERS}/edit/${membershipId}`,
        name: 'navigation.my-teams-member-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.COMPANY_TEAMS}/${isCurrent ? `current` : companyId}/edit/${teamId}`);

  /**
   * Loads team
   */
  const fetchMember = async () => {
    if (!membershipId) return;
    const response = await http.apiGet({
      url: `${apiUrl.TEAM_MEMBER_GET}?id=${Number(membershipId)}`,
    });
    setMember(response?.data);
  };

  useEffect(() => {
    fetchMember();
  }, []);

  if (!member) return <Loader />;
  return (
    <>
      <h1 className="text-3xl font-bold">{t('page.team-member.headline-edit')}</h1>
      <div className="flex">
        <div className="w-1/2 pr-10">
          <TeamMemberForm initialValues={{ userName: member.userName }} onBack={handleOnBack} />
        </div>
      </div>
    </>
  );
};
